import type { TargetOrganization } from '@/session/identity';
import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { IntegrationAllowance } from '@/types/integration';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  target: TargetOrganization;
  data: Partial<IntegrationAllowance>[];
};

type Response = IntegrationAllowance[];

export const bulkCreateIntegrationAllowances = async (
  { target, data }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const stampedData = data.map((row) => ({ ...row, organization_id: target.id }));
    const response = await scopedApi(GLOBAL_SCOPE).post<EndpointResponse<Response>>('integration_allowance/bulk', stampedData, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
